
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h900v600H0z"}}),_c('path',{attrs:{"fill":"#006233","d":"M0 0h450v600H0z"}}),_c('path',{attrs:{"fill":"#d21034","d":"M580 225a150 150 0 100 150 120 120 0 110-150m5 75l-135-44 84 115V229l-84 115z"}})])
          )
        }
      }
    